const tooltips = {
  nyugtak: 'A nyugtákat kibocsátóra (kötelező), állapotra, egy megadott időszakra, illetve egy adott bizonylatszámra lehet lekérdezni a rendszerből. Helyszín jogosultság kezelése esetében csak az adott helyszín(ek)hez kapcsolódó nyugták kérdezhetőek le.',
  napiosszesito: 'Kibocsátóra és napra összesítve lehet lekérni a Normál és a Sztornó típusú nyugták összegét és darabszámát. Helyszín jogosultág kezelése esetében csak az adott helyszín(ek) szerinti kibocsátó(k) nyugtái kérdezhetők le.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
